import React from "react";
import Icon from "../icon/icon";
import "./arrowIcon.scss";

export interface IArrowIconProps {
  relative?: boolean;
  className?: string;
  right?: number;
  onClick?: React.MouseEventHandler<Element>;
  useCloseIcon?: boolean;
  flip?: boolean;
}

function ArrowIcon(props: IArrowIconProps) {
  return (
    <Icon
      className={`arrow-icon-img ${props.relative ? "relative" : ""} ${
        props.className ? props.className : ""
      }`}
      style={
        props.right
          ? {
              position: "absolute",
              right: props.right ? props.right : undefined,
            }
          : {}
      }
      onClick={props.onClick}
    >
      {props.useCloseIcon ? "close" : props.flip ? "east" : "west"}
    </Icon>
  );
}

export default ArrowIcon;
